import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { WorkPage } from '../components/work-page.tsx';
import { PlanRequiredPage, usePlanFeature } from '../components/plan-gate.tsx';
import TodayRoute from '../components/schedule/today-route.tsx';
import { useDocumentTitle } from '../hooks/index.ts';

/** Today's route for whoever is signed in: their visits in booked order, one tap to drive to the next. */
export default function TodayPage() {
  const { t } = useTranslation();
  const scheduling = usePlanFeature('scheduling');
  useDocumentTitle(t('todayRoute.title'));
  if (!scheduling) return <PlanRequiredPage feature="scheduling" title={t('todayRoute.title')} />;
  return (
    <WorkPage
      title={t('todayRoute.title')}
      description={t('todayRoute.intro')}
      actions={
        <Link to="/schedule" className="btn btn-secondary">
          {t('todayRoute.fullSchedule')}
        </Link>
      }
    >
      <TodayRoute />
    </WorkPage>
  );
}
